// Family: Sibling Rally, family members, Family Cheers, recap sharing and
// encouragement reminders.
import { FamilyRally } from "../FamilyRally";
import { FamilyPanel } from "../../FamilyPanel";
import { RecapSharingPanel } from "../../RecapSharingPanel";
import { FamilyCheersPanel } from "../../FamilyCheersPanel";
import { EncouragementReminderPanel } from "../../EncouragementReminderPanel";

export const FamilySection = ({ user }) => (
  <div className="space-y-8" data-testid="dash-section-family">
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold font-display">Family</h1>
      <p className="text-muted-foreground mt-1">
        Sibling Rally, family members and cheers.
      </p>
    </div>
    <div className="space-y-4">
      <FamilyRally />
      <FamilyPanel />
      {!user?.joined_family_at && (
        <>
          <RecapSharingPanel />
          <FamilyCheersPanel />
        </>
      )}
      <EncouragementReminderPanel />
    </div>
  </div>
);
